import { Typography } from '@mui/material';
import React from 'react';

function useDescuentoFormat() {
  const showModificacion = (type = null, value) => {
    if (type) {
      if (type === 'discount') {
        // return { value: `-${value}`, color: 'error' };
        return <Typography color="error">{`-${value}`}</Typography>;
      }
      if (type === 'increase') {
        // return { value: `+${value}`, color: 'info' };
        return <Typography color="secondary">{`+${value}`}</Typography>;
      }
    }

    // return { value: 0, color: 'initial' };
    return <Typography>0</Typography>;
  };

  return { showModificacion };
}

export default useDescuentoFormat;
